import { ColumnDef } from '@tanstack/react-table';
import { AdminTableInfoDto } from '@repo/common-types';
import ROUTES from '@/routes/routes-enums';

export const tableColumns = (navigate): ColumnDef<AdminTableInfoDto>[] => [
  {
    accessorKey: 'name',
    header: 'Table Name',
    size: 300,
    cell: ({ row }) => (
      <a
        className="text-decoration-underline cursor-pointer"
        onClick={() => navigate(`${ROUTES.TABLE}/${row.original.id}`)}
      >
        <span>{row.original.name}</span>
        <p className="small mb-0">{row.original.variants[0]?.replace(/([a-z])([A-Z])/g, '$1 $2')}</p>
      </a>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'contractId',
    header: 'Contract ID',
    cell: ({ row }) => <div className="text-end">{row.original.contractId}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'maxPlayers',
    header: 'Max Players',
    cell: ({ row }) => <div className="text-end">{row.original.maxPlayers}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'seatCount',
    header: 'Players',
    cell: ({ row }) => <div className="text-end">{row.original.seatCount}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'minBuyin',
    header: 'Buy In Min',
    cell: ({ row }) => <div className="text-end">{row.original.minBuyin}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'maxBuyin',
    header: 'Buy In Max',
    cell: ({ row }) => <div className="text-end">{row.original.maxBuyin}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'smallBlind',
    header: 'Small Blind',
    cell: ({ row }) => <div className="text-end">{row.original.smallBlind}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'bigBlind',
    header: 'Big Blind',
    cell: ({ row }) => <div className="text-end">{row.original.bigBlind}</div>,
    enableSorting: true,
  },
  {
    accessorKey: 'isPublic',
    header: 'Is Public',
    cell: ({ row }) => (row.original.isPublic ? 'Yes' : 'No'),
    enableSorting: true,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => row.original.status,
    enableSorting: true,
  },
];
